import React, {Component, useState} from 'react';
import '../styles/chatty.css';
import {faqContent} from "../data/FAQContent";
import { Accordion, Icon } from "semantic-ui-react";

class QuickStartContent extends Component {

    constructor(props) {
        super(props)
    }

    state = { activeIndex: 0 };

    handleClick = (e, titleProps) => {
        const { index } = titleProps;
        const { activeIndex } = this.state;
        const newIndex = activeIndex === index ? -1 : index;

        this.setState({ activeIndex: newIndex })
    };

    Content1 = () => {
        const { activeIndex } = this.state;
        return (
            <>
                <Accordion.Title
                    active = {activeIndex === 0}
                    index = {0}
                    onClick = {this.handleClick}
                >
                    <Icon name='dropdown' /> Uniquely Identifying Accounts
                </Accordion.Title>
                <Accordion.Content active={activeIndex == 0}>
                    <div className="ui attached success message">
                        <div className="header">
                            Every account you add with us has 2 identifying pieces
                        </div>

                        <div className="ui card">
                            <div className={"content"}>
                                <div className={"header"}>
                                    Institution Name
                                </div>
                                <div className={"description"}>
                                    Bears the name of the institution where you opened your account.
                                </div>
                            </div>
                            <div className={"content"}>
                                <div className={"header"}>
                                    Account Type
                                </div>
                                <div className={"description"}>
                                    Specifies the type of account such as if it's a checking, savings, or credit accounts.
                                </div>
                            </div>
                        </div>
                    </div>
                </Accordion.Content>
            </>
        )
    };

    Content2 = () => {
        const faqs = faqContent;
        const { activeIndex } = this.state;

        return (
            <>
                {faqs.map( (faq, i) => (
                    <>
                        <Accordion.Title
                            active = {activeIndex == (i+1)}
                            index = {i+1}
                            onClick = {this.handleClick}
                        >
                            <Icon name='dropdown' /> {faq.title}
                        </Accordion.Title>

                        <Accordion.Content active={activeIndex == (i+1)}>
                            <div className="ui attached success message">
                                <div className="header">
                                    {faq.head}
                                </div>

                                <div className={"chat-body"}>
                                    <div className="chat-container darker">
                                        <img src="/img/user.png" alt="Avatar" style={{width:'100%'}}/>
                                        <h4 style={{'textAlign': 'left', margin: 'auto', color: 'azure', 'fontStyle': 'italic'}}>{faq.question}</h4>
                                    </div>

                                    <div className="chat-container">
                                        <img src="/img/echo.jpeg" alt="Avatar" className="right"  style={{width:'100%'}}/>
                                        <h4 style={{'textAlign': 'right', margin: 'auto', color: 'azure', 'fontStyle': 'italic'}}>{faq.response}</h4>
                                    </div>
                                </div>

                            </div>
                        </Accordion.Content>
                    </>
                ))}
            </>
        )
    };

    render() {
        return (
            <Accordion fluid styled>
                {this.Content1()}
                {this.Content2()}
            </Accordion>
        )
    }
}

export function QuickStartModal() {
    return (
        <div className={"ui basic modal"} id={"quickStartModal"}>
            <i className={"close icon"}></i>
            <h3 className={"ui header"}> Quick Start &nbsp; &nbsp;
                <span> <a href={"/quick-start"}> <i className={"external alternate icon"}></i>  </a> </span>
            </h3>
            <QuickStartContent container = {"modal"} />
        </div>
    )
}

export function QuickStartPage() {
    return(
        <>
            <div className={"ui grid"} style={{"margin-bottom": "1rem"}}>
                <div className={"one wide column"}></div>
                <div className={"fourteen wide column"}>
                    <h3 className={"ui header"}> Quick Start </h3>
                    <QuickStartContent container={"page"} />
                </div>
                <div className={"one wide column"}></div>
            </div>
            <div style={{"height":"45vh"}}></div>
        </>
    )
}